import loadable from '@loadable/component';
export const LandingPage=loadable(() => import('./LandingPage'));
 